<template>
  <div>
    <v-dialog
      v-model="waitlistMenu"
      :close-on-content-click="false"
      :nudge-right="40"
      transition="scale-transition"
      offset-y
      width="100%"
      max-width="500px"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          color="primary"
          outlined
          small
          class="ml-2"
          v-bind="attrs"
          v-on="on"
          >{{ activatorLabel }}</v-btn
        >
      </template>
      <v-card style="padding: 30px">
        <v-row>
          <v-col class="noHorizontalPadding">
            <v-card width="100%" elevation="0" outlined>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title class="text-wrap"
                    >{{ from.name }} to {{ to.name }}</v-list-item-title
                  >
                  <v-list-item-subtitle>{{
                    computedDate
                  }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-card>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="noHorizontalPadding">
            <v-text-field
              v-if="forcedPreferredTime"
              outlined
              readonly
              label="Preferred Time"
              :value="forcedPreferredTime"
              hide-details
            ></v-text-field>

            <v-select
              v-else
              outlined
              :items="['Morning', 'Noon', 'Afternoon']"
              label="Preferred Time"
              v-model="preferredTime"
              hide-details
            ></v-select>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="noHorizontalPadding">
            <vue-tel-input
              :inputOptions="telInputOptions"
              defaultCountry="mv"
              @input="phoneInput"
              style="height: 56px; font-size: 16px"
            ></vue-tel-input>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="noHorizontalPadding">
            <v-text-field
              outlined
              placeholder="Enter email address"
              v-model="email"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row style="margin-top: -10px; justify-content: space-between">
          <div></div>
          <v-btn
            outlined
            color="primary"
            :loading="waitlisting"
            @click="waitlist"
            >Waitlist</v-btn
          >
        </v-row>
      </v-card>
    </v-dialog>

    <v-dialog v-model="thankYouMenu" max-width="650px">
      <v-card style="padding: 24px">
        <v-card-title class="text-wrap" style="padding-left: 0px">
          Thank you for your interest in waitlisting for this trip!
        </v-card-title>
        <v-card-text style="padding-left: 0px">
          <v-progress-linear
            v-if="waitlistCountLoading"
            indeterminate
            color="primary"
            class="mb-4"
          ></v-progress-linear>
          <div v-if="waitlistCountShow" class="mb-4">
            Current waitlist count for this time period:
            <strong>{{ waitlistCount }}</strong>
          </div>
          <div>
            A new boat trip will be scheduled for this time period once we
            receive sufficient bookings.
          </div>
          <br />
          <div>
            We will notify you by sms/email as soon as another speedboat for
            this time period is scheduled. At that time, you will need to
            complete payment promptly to secure and guarantee your seat, as
            spots are limited and allocated on a first-come, first-served basis.
          </div>
          <br />
          <div>We thank and appreciate your patience until then!</div>
        </v-card-text>
        <v-card-actions style="padding-left: 0px">
          <div></div>
          <v-spacer></v-spacer>
          <v-btn color="primary" outlined @click="thankYouMenu = false"
            >OK</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";

export default {
  name: "Waitlist",
  props: {
    from: Object,
    to: Object,
    date: String,
    computedDate: String,
    activatorLabel: {
      type: String,
      default: "Waitlist",
    },
    preferredTimeKey: {
      type: String,
      default: null,
    },
    forcedPreferredTime: {
      type: String,
      default: null,
    },
    showThankYouModal: {
      type: Boolean,
      default: false,
    },
    message: Function,
    errorMessage: Function,
  },
  data: () => ({
    waitlistMenu: null,
    thankYouMenu: false,
    waitlistCountLoading: false,
    waitlistCountShow: false,
    waitlistCount: 0,
    telInputOptions: { placeholder: "Enter phone number" },
    preferredTime: null,
    phone: "",
    email: "",
    waitlisting: false,
  }),
  methods: {
    fetchWaitlistCount(preferredTime) {
      if (!preferredTime) return Promise.resolve();
      if (!this.from || !this.to) return Promise.resolve();

      const dateISO = moment(this.date, "YYYY-MM-DD")
        .startOf("day")
        .toISOString();
      this.waitlistCountLoading = true;
      return axios({
        url: `${
          process.env.VUE_APP_BASE_URL ?? ""
        }/api/getwaitlistcount?date=${encodeURIComponent(
          dateISO
        )}&fromLocationId=${encodeURIComponent(
          this.from.id
        )}&toLocationId=${encodeURIComponent(
          this.to.id
        )}&preferredTime=${encodeURIComponent(preferredTime)}`,
        method: "GET",
      })
        .then((resp) => {
          if (resp.data?.show !== true) {
            this.waitlistCountShow = false;
            this.waitlistCount = 0;
            return;
          }
          const count = Number(resp.data?.count ?? 0);
          this.waitlistCount = isNaN(count) ? 0 : count;
          this.waitlistCountShow = true;
        })
        .catch(() => {
          this.waitlistCountShow = false;
          this.waitlistCount = 0;
        })
        .finally(() => {
          this.waitlistCountLoading = false;
        });
    },
    phoneInput(phone, phoneObject) {
      this.phone = phoneObject;
    },
    waitlist() {
      const preferredTime =
        this.preferredTimeKey || this.forcedPreferredTime || this.preferredTime;
      if (!preferredTime) {
        this.errorMessage("No preferred time chosen.");
        return;
      }
      if (!this.from || !this.to) {
        this.errorMessage("Both locations not selected.");
        return;
      }
      const data = {
        preferredTime,
        fromLocationId: this.from.id,
        toLocationId: this.to.id,
        date: moment(this.date, "YYYY-MM-DD").startOf("day").toISOString(),
        phone: this.phone.number,
        phoneCountryCode: this.phone.countryCode,
        email: this.email,
      };
      this.waitlisting = true;
      axios({
        url: `${process.env.VUE_APP_BASE_URL ?? ""}/api/createwaitlist`,
        method: "POST",
        data: JSON.stringify(data),
      })
        .then((resp) => {
          if (!this.showThankYouModal) {
            this.message(resp.data.message);
          }
          this.preferredTime = null;
          this.email = "";
          this.phone = "";
          this.waitlistMenu = false;
          if (this.showThankYouModal) {
            this.waitlistCountShow = false;
            this.waitlistCount = 0;
            this.thankYouMenu = true;
            this.fetchWaitlistCount(preferredTime);
          }
        })
        .catch((error) => {
          if (error.response) {
            this.errorMessage(error.response.data.error);
          }
        })
        .finally(() => (this.waitlisting = false));
    },
  },
};
</script>

<style scoped>
.noHorizontalPadding {
  padding-left: 0px;
  padding-right: 0px;
}
.noVerticalPadding {
  padding-top: 0px;
  padding-bottom: 0px;
}
</style>
